"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/customerSelection',["require", "exports", "knockout", "controllers/policyHolderSelectionController", "models/userIdentityModel", "moment", "routing/mainRouter", "services/environmentSelectionService"], function (require, exports, ko, policyHolderSelectionController, userIdentityModel, moment, mainRouter, environmentSelectionService) {
    "use strict";

    var CustomerSelection = function () {
        function CustomerSelection() {
            _classCallCheck(this, CustomerSelection);

            this.policyCache = ko.observableArray();
            this.loading = ko.observable();
        }

        _createClass(CustomerSelection, [{
            key: "resetDeferreds",
            value: function resetDeferreds() {
                this.vehiclesForPolicyDeferred = $.Deferred();
            }
        }, {
            key: "sendRebuildFromDateRequest",
            value: function sendRebuildFromDateRequest(policy, date) {
                return policyHolderSelectionController.sendRebuildFromDateRequest({
                    brokerPolicyId: policy.brokerPolicyId,
                    policyId: policy.id,
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: policy.coverStartDate,
                    coverEndDate: policy.coverEndDate,
                    date: date
                });
            }
        }, {
            key: "fetchDeviceReplacementRequests",
            value: function fetchDeviceReplacementRequests(policyHolderId, policyId) {
                var _this = this;

                return policyHolderSelectionController.fetchDeviceReplacementRequests({
                    policyHolderId: policyHolderId,
                    environment: mainRouter.router.environmentId()
                }).fail(function (e) {
                    _this.myfail(e);
                });
            }
        }, {
            key: "convertDate",
            value: function convertDate(inputFormat) {
                function pad(s) {
                    return s < 10 ? '0' + s : s;
                }
                var d = new Date(inputFormat);
                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            }
        }, {
            key: "getAccidentAndIncidentSummary",
            value: function getAccidentAndIncidentSummary(policyId, brokerPolicyId, coverStartDate, coverEndDate, date) {
                var _this2 = this;

                var request = {
                    date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentAndIncidentSummary(request).fail(function (e) {
                    _this2.myfail(e);
                });
            }
        }, {
            key: "getAccidentAndIncidentChartData",
            value: function getAccidentAndIncidentChartData(policyId, brokerPolicyId, coverStartDate, coverEndDate, date) {
                var request = {
                    date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentAndIncidentChartData(request);
            }
        }, {
            key: "getAccidentsAndIncidentGridDataForDate",
            value: function getAccidentsAndIncidentGridDataForDate(policyId, brokerPolicyId, coverStartDate, coverEndDate, date) {
                var request = {
                    date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentsAndIncidentsGridData(request);
            }
        }, {
            key: "getAccidentsAndIncidentGridDataForThisWeek",
            value: function getAccidentsAndIncidentGridDataForThisWeek(policyId, brokerPolicyId, coverStartDate, coverEndDate) {
                var request = {
                    date: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentsAndIncidentsDataThisWeek(request);
            }
        }, {
            key: "getAccidentsAndIncidentGridDataForThisMonth",
            value: function getAccidentsAndIncidentGridDataForThisMonth(policyId, brokerPolicyId, coverStartDate, coverEndDate) {
                var request = {
                    date: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentsAndIncidentsDataThisMonth(request);
            }
        }, {
            key: "getAccidentsAndIncidentGridDataForThisYear",
            value: function getAccidentsAndIncidentGridDataForThisYear(policyId, brokerPolicyId, coverStartDate, coverEndDate) {
                var request = {
                    date: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getAccidentsAndIncidentsDataThisYear(request);
            }
        }, {
            key: "getIncidentSummary",
            value: function getIncidentSummary(policyId, brokerPolicyId, coverStartDate, coverEndDate, date) {
                var _this3 = this;

                var request = {
                    date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getIncidentSummary(request).fail(function (e) {
                    _this3.myfail(e);
                });
            }
        }, {
            key: "getIncidentChartData",
            value: function getIncidentChartData(policyId, brokerPolicyId, coverStartDate, coverEndDate, date) {
                var request = {
                    date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    insurerId: userIdentityModel.insurerId(),
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                };
                return policyHolderSelectionController.getIncidentChartData(request);
            }
        }, {
            key: "saveAccidentReport",
            value: function saveAccidentReport(policyId, gpsDateTime, report) {
                var request = {
                    policyId: policyId,
                    gpsDateTime: gpsDateTime,
                    report: report
                };
                return policyHolderSelectionController.saveAccidentReport(request);
            }
        }, {
            key: "requestDeviceReplacement",
            value: function requestDeviceReplacement(date, reason, userId, policyHolderId, policyId) {
                var _this4 = this;

                return policyHolderSelectionController.requestDeviceReplacement({
                    date: this.convertDate(date),
                    reason: reason,
                    userId: userId,
                    policyHolderId: policyHolderId,
                    policyId: policyId,
                    environment: mainRouter.router.environmentId()
                }).fail(function (e) {
                    _this4.myfail(e);
                });
            }
        }, {
            key: "rebuildAllJourneysForImei",
            value: function rebuildAllJourneysForImei(policyId, brokerPolicyId, brokerPolicyholderId, policyHolderFullName, imei, allocationStartDate, fetchRoadData) {
                return policyHolderSelectionController.rebuildAllJourneysForImei({
                    imei: imei,
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    environment: mainRouter.router.environmentId(),
                    allocationStartDate: allocationStartDate,
                    fetchRoadData: fetchRoadData,
                    brokerPolicyholderId: brokerPolicyholderId,
                    policyHolderFullName: policyHolderFullName
                });
            }
        }, {
            key: "getAllPoliciesForPolicyHolder",
            value: function getAllPoliciesForPolicyHolder(brokerPolicyHolderId) {
                return policyHolderSelectionController.getAllPoliciesForPolicyHolder({
                    insurerId: userIdentityModel.insurerId(),
                    policyHolderId: brokerPolicyHolderId,
                    environmentId: mainRouter.router.environmentId()
                });
            }
        }, {
            key: "getAllVehicles",
            value: function getAllVehicles(policyId) {
                return policyHolderSelectionController.getAllVehiclesForPolicy({
                    insurerId: userIdentityModel.insurerId(),
                    policyId: policyId,
                    environmentId: mainRouter.router.environmentId()
                });
            }
        }, {
            key: "getDvlaInfoForVehicle",
            value: function getDvlaInfoForVehicle(vehicleRegistration, vehicleId, motExpiryDate, taxExpiryDate, dateOfLastV5CIssued) {
                return policyHolderSelectionController.getDvlaInfoForVehicle({
                    vehicleRegistration: vehicleRegistration,
                    vehicleId: vehicleId,
                    motExpiryDate: motExpiryDate,
                    taxExpiryDate: taxExpiryDate,
                    dateOfLastV5CIssued: dateOfLastV5CIssued,
                    environmentId: mainRouter.router.environmentId()
                });
            }
        }, {
            key: "getAllAddresses",
            value: function getAllAddresses(brokerPolicyHolderId) {
                var _this5 = this;

                return policyHolderSelectionController.getAllAddressesForPolicyHolder({
                    insurerId: userIdentityModel.insurerId(),
                    policyHolderId: brokerPolicyHolderId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {
                    return _this5.myfail(e);
                });
            }
        }, {
            key: "getLatestUserActivityDates",
            value: function getLatestUserActivityDates(brokerPolicyId, policyId) {
                var _this6 = this;

                return policyHolderSelectionController.getLatestUserActivityDates({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {
                    _this6.myfail(e);
                });
            }
        }, {
            key: "getDeviceDetails",
            value: function getDeviceDetails(policyId, brokerPolicyId, coverStartDate, coverEndDate, policyHolderFullName, brokerPolicyHolderId) {
                var _this7 = this;

                return policyHolderSelectionController.getDeviceDataForImei({
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    environmentId: mainRouter.router.environmentId(),
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    policyHolderFullName: policyHolderFullName,
                    brokerPolicyHolderId: brokerPolicyHolderId
                }).fail(function (e) {
                    return _this7.myfail(e);
                });
            }
        }, {
            key: "getLastKnownLocation",
            value: function getLastKnownLocation(brokerPolicyId, coverStartDate, coverEndDate) {
                var _this8 = this;

                return policyHolderSelectionController.getLastKnownPositionForImei({
                    environmentId: mainRouter.router.environmentId(),
                    brokerPolicyId: brokerPolicyId,
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    insurerId: userIdentityModel.insurerId()
                }).fail(function (e) {
                    return _this8.myfail(e);
                });
            }
        }, {
            key: "getAverageLocation",
            value: function getAverageLocation(numberOfDays, brokerPolicyId, environment, insurerId) {
                var _this9 = this;

                return policyHolderSelectionController.getAverageLocation({
                    numberOfDays: numberOfDays,
                    brokerPolicyID: brokerPolicyId,
                    environment: environment,
                    insurerId: insurerId
                }).fail(function (e) {
                    return _this9.myfail(e);
                });
            }
        }, {
            key: "getCommutingData",
            value: function getCommutingData(brokerPolicyId, environment, insurerId, postCode, policyId, overnightStartDate, overnightEndDate) {
                var _this10 = this;

                return policyHolderSelectionController.getCommutingData({
                    brokerPolicyId: brokerPolicyId,
                    environment: environment,
                    insurerId: insurerId,
                    postcode: postCode,
                    policyId: policyId,
                    commutingStartDate: overnightStartDate,
                    commutingEndDate: overnightEndDate
                }).fail(function (e) {
                    return _this10.myfail(e);
                });
            }
        }, {
            key: "getBusinessData",
            value: function getBusinessData(brokerPolicyId, environment, insurerId, postCode, policyId, overnightStartDate, overnightEndDate) {
                var _this11 = this;

                return policyHolderSelectionController.getBusinessData({
                    brokerPolicyId: brokerPolicyId,
                    environment: environment,
                    insurerId: insurerId,
                    postcode: postCode,
                    policyId: policyId,
                    businessStartDate: overnightStartDate,
                    businessEndDate: overnightEndDate
                }).fail(function (e) {
                    return _this11.myfail(e);
                });
            }
        }, {
            key: "getOverNightLocation",
            value: function getOverNightLocation(brokerPolicyId, environment, insurerId, postCode, policyId, overnightStartDate, overnightEndDate) {
                var _this12 = this;

                return policyHolderSelectionController.getOverNightLocation({
                    brokerPolicyId: brokerPolicyId,
                    environment: environment,
                    insurerId: insurerId,
                    postcode: postCode,
                    policyId: policyId,
                    overnightStartDate: overnightStartDate,
                    overnightEndDate: overnightEndDate
                }).fail(function (e) {
                    return _this12.myfail(e);
                });
            }
        }, {
            key: "getCreatedDatePosition",
            value: function getCreatedDatePosition(insurerId, environmentId, brokerPolicyId, coverStartDate, coverEndDate) {
                var _this13 = this;

                return policyHolderSelectionController.getCreatedDatePosition({
                    insurerId: insurerId,
                    environmentId: environmentId,
                    brokerPolicyId: brokerPolicyId,
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate
                }).fail(function (e) {
                    return _this13.myfail(e);
                });
            }
        }, {
            key: "updateRiskLatLng",
            value: function updateRiskLatLng(policyId, riskLatitude, riskLongitude, environment, insurerId) {
                var _this14 = this;

                return policyHolderSelectionController.updateRiskLatLng({
                    policyId: policyId,
                    riskLatitude: riskLatitude,
                    riskLongitude: riskLongitude,
                    environment: environment,
                    insurerId: insurerId
                }).fail(function (e) {
                    return _this14.myfail(e);
                });
            }
        }, {
            key: "getVehiclePolicyHistory",
            value: function getVehiclePolicyHistory(brokerPolicyId) {
                return policyHolderSelectionController.getPolicyHistory({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {});
            }
        }, {
            key: "getPolicyHolderHistory",
            value: function getPolicyHolderHistory(brokerPolicyHolderId) {
                var _this15 = this;

                return policyHolderSelectionController.getPolicyHolderHistory({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {
                    return _this15.myfail(e);
                });
            }
        }, {
            key: "getPolicyHistory",
            value: function getPolicyHistory(brokerPolicyId) {
                return policyHolderSelectionController.getPolicyHistory({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {});
            }
        }, {
            key: "getInsuranceClaims",
            value: function getInsuranceClaims(brokerPolicyId) {
                return policyHolderSelectionController.getInsuranceClaims(mainRouter.router.environmentId(), brokerPolicyId);
            }
        }, {
            key: "getAddressHistory",
            value: function getAddressHistory(addressId) {
                return policyHolderSelectionController.getAddressHistory({
                    insurerId: userIdentityModel.insurerId(),
                    addressId: addressId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {});
            }
        }, {
            key: "getAddressTileHistory",
            value: function getAddressTileHistory(addressId) {
                return policyHolderSelectionController.getAddressHistory({
                    insurerId: userIdentityModel.insurerId(),
                    addressId: addressId,
                    environmentId: mainRouter.router.environmentId()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPoliciesByClientId",
            value: function getMidweightPoliciesByClientId(clientId, environment) {
                return policyHolderSelectionController.getMidweightPoliciesByClientId({
                    insurerId: userIdentityModel.insurerId(),
                    value: clientId,
                    environmentId: environment || this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPolicyByBrokerPolicyId",
            value: function getMidweightPolicyByBrokerPolicyId(brokerPolicyId) {
                return policyHolderSelectionController.getMidweightPolicyByBrokerPolicyId({
                    insurerId: userIdentityModel.insurerId(),
                    value: brokerPolicyId,
                    environmentId: this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPolicyByBillingRef",
            value: function getMidweightPolicyByBillingRef(billingRef) {
                return policyHolderSelectionController.getMidweightPolicyByBillingRef({
                    insurerId: userIdentityModel.insurerId(),
                    value: billingRef,
                    environmentId: this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPolicyByPolicyId",
            value: function getMidweightPolicyByPolicyId(policyId) {
                return policyHolderSelectionController.getMidweightPolicyByPolicyId({
                    insurerId: userIdentityModel.insurerId(),
                    value: policyId,
                    environmentId: this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPolicyByVehicleReg",
            value: function getMidweightPolicyByVehicleReg(vehicleReg, environment) {
                return policyHolderSelectionController.getMidweightPolicyByVehicleReg({
                    insurerId: userIdentityModel.insurerId(),
                    value: vehicleReg,
                    environmentId: environment || this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPoliciesByImei",
            value: function getMidweightPoliciesByImei(imei) {
                return policyHolderSelectionController.getMidweightPoliciesByImei({
                    insurerId: userIdentityModel.insurerId(),
                    value: imei,
                    environmentId: this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getMidweightPoliciesByUnitSerialNumber",
            value: function getMidweightPoliciesByUnitSerialNumber(unitSerialNumber) {
                return policyHolderSelectionController.getMidweightPoliciesByUnitSerialNumber({
                    insurerId: userIdentityModel.insurerId(),
                    value: unitSerialNumber,
                    environmentId: this.getEnvironment()
                }).fail(function (e) {});
            }
        }, {
            key: "getFullPolicyDetails",
            value: function getFullPolicyDetails(brokerPolicyId, policyId, env) {
                var _this16 = this;

                return policyHolderSelectionController.getFullPolicyDetails({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    environmentId: env || mainRouter.router.environmentId(),
                    sessionId: userIdentityModel.sessionId()
                }).fail(function (e) {
                    return _this16.fail(e);
                });
            }
        }, {
            key: "getFullPolicyDetailsEnvSpecific",
            value: function getFullPolicyDetailsEnvSpecific(env, brokerPolicyId, policyId) {
                var _this17 = this;

                return policyHolderSelectionController.getFullPolicyDetails({
                    insurerId: userIdentityModel.insurerId(),
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    environmentId: env,
                    sessionId: userIdentityModel.sessionId()
                }).fail(function (e) {
                    return _this17.fail(e);
                });
            }
        }, {
            key: "getFullPolicyDetailsEnvAndInsSpecific",
            value: function getFullPolicyDetailsEnvAndInsSpecific(env, brokerPolicyId, policyId, insurerId) {
                var _this18 = this;

                return policyHolderSelectionController.getFullPolicyDetails({
                    insurerId: insurerId,
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    environmentId: env,
                    sessionId: userIdentityModel.sessionId()
                }).fail(function (e) {
                    return _this18.fail(e);
                });
            }
        }, {
            key: "getDeviceAllocations",
            value: function getDeviceAllocations(policyId) {
                return policyHolderSelectionController.getDeviceAllocations({
                    insurerId: userIdentityModel.insurerId(),
                    policyId: policyId,
                    environmentId: mainRouter.router.environmentId(),
                    sessionId: userIdentityModel.sessionId()
                });
            }
        }, {
            key: "updatePolicyVehicle",
            value: function updatePolicyVehicle(vehicleId, registration, make, model, year, colour, allocatedDate, terminatedDate, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                var _this19 = this;

                return policyHolderSelectionController.updatePolicyVehicle({
                    environmentId: mainRouter.router.environmentId(),
                    vehicleId: vehicleId,
                    registration: registration,
                    make: make,
                    model: model,
                    year: year,
                    colour: colour,
                    allocatedDate: allocatedDate,
                    terminatedDate: terminatedDate,
                    policyId: policyId,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName
                }).fail(function (e) {
                    return _this19.fail(e);
                });
            }
        }, {
            key: "deletePolicyVehicle",
            value: function deletePolicyVehicle(policyVehicleId, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                var _this20 = this;

                return policyHolderSelectionController.deletePolicyVehicle({
                    environmentId: mainRouter.router.environmentId(),
                    policyVehicleId: policyVehicleId,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    policyId: policyId
                }).fail(function (e) {
                    return _this20.fail(e);
                });
            }
        }, {
            key: "updateAddress",
            value: function updateAddress(addressId, addressLine1, addressLine2, addressLine3, addressLine4, postCode, isActive, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                return policyHolderSelectionController.updateAddress({
                    environmentId: mainRouter.router.environmentId(),
                    id: addressId,
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    addressLine3: addressLine3,
                    addressLine4: addressLine4,
                    postCode: postCode,
                    isActive: isActive,
                    policyId: policyId,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName
                });
            }
        }, {
            key: "suggestShippingAddress",
            value: function suggestShippingAddress(addressLine1, addressLine2, addressLine3, addressLine4, postCode, service, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                return policyHolderSelectionController.suggestShippingAddress({
                    environmentId: mainRouter.router.environmentId(),
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    addressLine3: addressLine3,
                    addressLine4: addressLine4,
                    postCode: postCode,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    isActive: true,
                    policyId: policyId,
                    service: service
                });
            }
        }, {
            key: "addShippingAddress",
            value: function addShippingAddress(addressLine1, addressLine2, addressLine3, addressLine4, postCode, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                return policyHolderSelectionController.addShippingAddress({
                    environmentId: mainRouter.router.environmentId(),
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    addressLine3: addressLine3,
                    addressLine4: addressLine4,
                    postCode: postCode,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    isActive: true,
                    policyId: policyId
                });
            }
        }, {
            key: "addDeviceAllocation",
            value: function addDeviceAllocation(allocatedDate, dispatchDate, deliveredDate, activatedDate, terminatedDate, trackingNumber, boxId, reason, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                return policyHolderSelectionController.addDeviceAllocation({
                    environmentId: mainRouter.router.environmentId(),
                    allocatedDate: moment(allocatedDate).format('YYYY-MM-DDTHH:mm:ss'),
                    dispatchDate: dispatchDate ? moment(dispatchDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    deliveredDate: deliveredDate ? moment(deliveredDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    activatedDate: activatedDate ? moment(activatedDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    terminatedDate: terminatedDate ? moment(terminatedDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    trackingNumber: trackingNumber,
                    boxId: boxId,
                    reason: reason,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    policyId: policyId
                });
            }
        }, {
            key: "updateDeviceAllocation",
            value: function updateDeviceAllocation(deviceAllocationId, allocatedDate, dispatchDate, deliveredDate, activatedDate, terminatedDate, trackingNumber, boxId, reason, policyId, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                return policyHolderSelectionController.updateDeviceAllocation({
                    environmentId: mainRouter.router.environmentId(),
                    deviceAllocationId: deviceAllocationId,
                    allocatedDate: moment(allocatedDate).format('YYYY-MM-DDTHH:mm:ss'),
                    dispatchDate: dispatchDate ? moment(dispatchDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    deliveredDate: deliveredDate ? moment(deliveredDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    activatedDate: activatedDate ? moment(activatedDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    terminatedDate: terminatedDate ? moment(terminatedDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    trackingNumber: trackingNumber,
                    boxId: boxId,
                    reason: reason,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    policyId: policyId
                });
            }
        }, {
            key: "deleteAllocation",
            value: function deleteAllocation(deviceAllocationId, boxId, policyId, reason, brokerPolicyholderId, brokerPolicyId, policyHolderFullName) {
                var _this21 = this;

                return policyHolderSelectionController.deleteDeviceAllocation({
                    environmentId: mainRouter.router.environmentId(),
                    deviceAllocationId: deviceAllocationId,
                    policyId: policyId,
                    boxId: boxId,
                    reason: reason,
                    brokerPolicyholderId: brokerPolicyholderId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName
                }).fail(function (e) {
                    return _this21.fail(e);
                });
            }
        }, {
            key: "fail",
            value: function fail(e) {}
        }, {
            key: "myfail",
            value: function myfail(e) {}
        }, {
            key: "getEnvironment",
            value: function getEnvironment() {
                return mainRouter.router.environmentId() || (environmentSelectionService.selectedEnvironment() ? environmentSelectionService.selectedEnvironment().id : '');
            }
        }]);

        return CustomerSelection;
    }();

    var customerSelection;
    customerSelection = new CustomerSelection();
    return customerSelection;
});
//# sourceMappingURL=customerSelection.js.map;
